export function ProbResult({ data, beat }) {
  const result = data.microtracerBeats[`beat${beat}`]?.probResult;
  return <>{result}</>;
}
